import {
  ACTN_REFRESH
} from "./action-types.js"; 
//import { Object } from "core-js";

const initialState = {
  selectedSize: {
    width: "205",
    ratio: "55",
    diameter: "16",
    load: "",
    speed: "",
    isrunflat: false,
    isxl: false,
    brand: ""
  }
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTN_REFRESH:
      //if (action.data.selectedSize) {
      //  return { ...state, selectedSize: action.data.selectedSize };
      //}
      //return state;
      if (action.data.selectedSize) {
        state = { ...state, selectedSize: action.data.selectedSize };
      }
      //if (action.data.selectedSize && action.data.selectedSize.width && action.data.selectedSize.ratio && action.data.selectedSize.diameter
      //  && action.data.selectedSize.brand && action.data.selectedSize.speed && action.data.selectedSize.load && action.data.selectedSize.isxl && action.data.selectedSize.isrunflat) {
      //  state = { ...state, selectedSize: action.data.selectedSize };
      //}
      ["widths", "ratios", "diameters", "speeds", "loads", "brands", "seasons", "defaults"]
        .forEach(p => {
          if (action.data[p]) {
            state[p] = action.data[p];
          }
        });
       return state;

    default:
      return state;
  }
};

export default searchReducer;